<template>
	<div class="page">
		<HeaderBar title="甲状腺功能"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400jzx.guid">
					<checkItem v-for="(item,index) in dataList" :key="index" :config="item" @setFormData="setFormData"
						v-model="form.bq400jzx">
					</checkItem>
				</van-cell-group>
				<FormNormalUpload label="上传报告" ref="normalUpload" :infoGuid='form.bq400jzx.guid'></FormNormalUpload>
				<div class="page-bottom-box" style="margin: 16px;"  v-show='!savestate'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq400jzx.guid!=''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>

	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page007",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400jzx',
				form: {
					bq400jzx: {

						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400107: "", //三碘甲状腺原氨酸
						bq4001072: "", //
						bq4001073: "", //
						bq400108: "", //四碘甲状腺原氨酸
						bq4001082: "", //
						bq4001083: "", //
						bq400109: "", //游离三碘甲状腺原氨酸
						bq4001092: "", //
						bq4001093: "", //
						bq400110: "", //游离型甲状腺素
						bq4001102: "", //
						bq4001103: "", //
						bq400111: "", //促甲状腺激素
						bq4001112: "", //
						bq4001113: "", //
						Bq400_guid: '', //随访基本信息表编号
						Bq400_107: '', //三碘甲状腺原氨酸
						Bq400_107_2: '', //值
						Bq400_107_3: '', //单位
						Bq400_108: '', //四碘甲状腺原氨酸
						Bq400_108_2: '', //值
						Bq400_108_3: '', //单位
						Bq400_109: '', //游离三碘甲状腺原氨酸
						Bq400_109_2: '', //值
						Bq400_109_3: '', //单位
						Bq400_110: '', //游离型甲状腺素
						Bq400_110_2: '', //值
						Bq400_110_3: '', //单位
						Bq400_111: '', //促甲状腺激素
						Bq400_111_2: '', //值
						Bq400_111_3: '', //单位
					},
					sempFiles: []
				},
				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400jzx/Save',
				dataList: [],
				bq400: JSON.parse(sessionStorage.getItem('bq400')),
				savestate:false,
			}
		},
		components: {
			...componentsModel
		},
		methods: {
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400jzx/Info', args, function(d) {
					let dataModel = d.Data
					if (dataModel != null) {
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.$set(that.form, "bq400jzx", dataModel)
					}
				}, null, null, null);
			},

			//保存信息
			SaveInfo: function() {
				let that = this
				that.savestate=true
				that.$utils.CopyKeySave(that.form.bq400jzx, that.form.bq400jzx)
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			this.form.bq400jzx.bq400guid = this.bq400.guid
			this.LoadDataList()
			this.LoadInfo()
		}
	}
</script>

<style scoped>

</style>
